import { Star, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { TableCell, TableRow } from "@/components/ui/table";
import {
  formatProfit,
  profitTone,
  formatEpochDate,
  shortHandId,
  gameModeLabel,
  boardToString,
} from "@/modules/collector_v2/lib/replayFormatters";

export function HandHistoryRow({ hand, onToggleCollect, onOpenReplay, busy = false }) {
  const tone = profitTone(hand.my_profit_visual ?? hand.profit_visual);
  const profitValue = hand.my_profit_visual ?? hand.profit_visual;
  const cards = hand.my_hole_cards ?? hand.hole_cards ?? [];

  return (
    <TableRow data-testid="hand-history-row" className="hover:bg-accent/40">
      <TableCell className="font-mono text-xs" title={hand.hand_id}>
        {shortHandId(hand.hand_id)}
      </TableCell>
      <TableCell>
        <div className="flex flex-col">
          <span className="text-sm font-medium">
            {hand.table_name || `Mesa ${hand.table_id}`}
          </span>
          <span className="text-[11px] text-muted-foreground">
            #{hand.table_id} · Club {hand.club_id ?? "—"}
          </span>
        </div>
      </TableCell>
      <TableCell>
        <Badge variant="outline" className="font-medium">
          {gameModeLabel(hand.game_mode)}
        </Badge>
      </TableCell>
      <TableCell>
        {hand.my_position ? (
          <Badge variant="secondary" className="text-[11px]">
            {hand.my_position}
          </Badge>
        ) : (
          <span className="text-muted-foreground text-xs">—</span>
        )}
      </TableCell>
      <TableCell className="font-mono text-xs">
        {cards.length > 0 ? (
          <span className="tracking-wide">{cards.join(" ")}</span>
        ) : (
          <span className="text-muted-foreground">—</span>
        )}
      </TableCell>
      <TableCell className="font-mono text-xs whitespace-nowrap">
        {boardToString(hand.board)}
      </TableCell>
      <TableCell
        className={`tabular-nums font-medium ${
          tone === "positive"
            ? "text-emerald-600"
            : tone === "negative"
            ? "text-rose-600"
            : ""
        }`}
      >
        {formatProfit(profitValue)}
      </TableCell>
      <TableCell className="text-xs text-muted-foreground whitespace-nowrap">
        {formatEpochDate(hand.started_at_raw)}
      </TableCell>
      <TableCell className="text-right">
        <div className="flex items-center justify-end gap-1">
          <Button
            size="icon"
            variant="ghost"
            disabled={busy}
            onClick={() => onToggleCollect?.(hand)}
            title={hand.is_collected ? "Quitar de colección" : "Agregar a colección"}
            data-testid={`hand-row-collect-btn-${hand.hand_id}`}
            className={hand.is_collected ? "text-amber-500 hover:text-amber-600" : ""}
          >
            <Star
              className="h-4 w-4"
              fill={hand.is_collected ? "currentColor" : "none"}
            />
          </Button>
          <Button
            size="icon"
            variant="ghost"
            onClick={() => onOpenReplay?.(hand)}
            title="Reproducir / ver detalle"
            data-testid={`hand-row-play-btn-${hand.hand_id}`}
          >
            <Play className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
